'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
type BrandContentProps = {
  initializeWebcollage: () => void;
};
export const BrandContentLegacy = t0 => {
  const $ = _c(2);
  const {
    initializeWebcollage
  } = t0;
  let t1;
  if ($[0] !== initializeWebcollage) {
    t1 = <Script id="webcollage-script" src="//scontent.webcollage.net/api/v2/product-content" strategy="afterInteractive" onLoad={initializeWebcollage} />;
    $[0] = initializeWebcollage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};